import React, { useEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from '../../../common/commonUtil';
import { replaceLineBreakCharToLineBreak } from '../../../pages_membership_hotel/hotel/membershipVacancy';
import "../../../resources/css/search/search.css";
import arrow from '../../../resources/icons/arw.svg';
import cross from '../../../resources/icons/ico_X.svg';
import circle from '../../../resources_membership_hotel/icons/ico_circle.svg';
import minus from '../../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../../resources_membership_hotel/icons/ico_slash.svg';
import square from '../../../resources_membership_hotel/icons/ico_square.svg';
import ico_square_blue from '../../../resources_membership_hotel/icons/ico_square_blue.svg';
import ico_square_gold from '../../../resources_membership_hotel/icons/ico_square_gold.svg';
import ico_square_red from '../../../resources_membership_hotel/icons/ico_square_red.svg';
import ico_square_white from '../../../resources_membership_hotel/icons/ico_square_white.svg';
import triangle from '../../../resources_membership_hotel/icons/ico_triangle.svg';
import { Image } from "../../atoms/image";
import { ImageButton } from '../../atoms/imageButton';
import { Label } from '../../atoms/label';
import { LoginBfWeeksDate } from '../../molecules/loginBfWeekDate';
import { WeeksDate } from '../../molecules/weeksDate';
import { WeeksDateMobile } from '../../molecules/weeksDateMobile';
import './../../../resources_membership_hotel/css/hotel/reserve.css';

// ログイン前空室照会画面の検索結果
const LoginBfVacancyInfoCallender = (props) => {
    const {
        checkIn,
        room,
        resvKaiinken,
        grade,
        membershipFacility,
        setMembershipFacility,
        setMembershipSearchParam,
        onClickOpenFacilityCalendarWindow,
        setDispFacility,
        setCheckIn,
        setCheckOut,
        firstDate,
        adultNum,
        childNum,
        toHotelSearchView,
        facilityData,
        state } = props;

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [nextFlag, setNextFlag] = useState(false);

    const store = useStore();
    const history = useHistory();

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    // モバイル版のカレンダー切替
    const onClickNextView = () => {
        setNextFlag(!nextFlag);
    }

    // 〇△を押下した場合の処理
    // ホテル予約に遷移して、日付を引継ぎ、施設選択〇△を押下した施設のみチェックした状態にする
    // 未ログインの場合は、ログイン画面を挟んでホテル予約に遷移。引継ぎは同じ。
    const toList = (facilityId, date) => {
        // ホテル検索に遷移
        toHotelSearchView(store, history, facilityId, date);
        // const checkInDate = new Date(date)
        // const checkOutDate = new Date(date)
        // checkOutDate.setDate(checkOutDate.getDate() + 1)
        // setCheckIn(checkInDate)
        // setCheckOut(checkOutDate)

        // 施設
        // let facilityArray = [];
        // facilityArray.push(facilityId);
        // let dispText = "";
        // let newMembership = [];
        // membershipFacility.membership.forEach(group => {
        //     group.checked = false
        //     group.shisetsuList.forEach(item => {
        //         if (item.id === facilityId) {
        //             dispText = dispText + (dispText == "" ? "" : ", ")
        //             dispText = dispText + item.value
        //             item.checked = true
        //         } else {
        //             item.checked = false
        //         }
        //     })
        //     newMembership.push(group)
        // })
        // let newIppan = []
        // membershipFacility.ippan.forEach(group => {
        //     group.checked = false
        //     group.shisetsuList.forEach(item => {
        //         if (item.id === facilityId) {
        //             dispText = dispText + (dispText == "" ? "" : ", ")
        //             dispText = dispText + item.value
        //             item.checked = true
        //         } else {
        //             item.checked = false
        //         }
        //     })
        //     newIppan.push(group)
        // })
        // setMembershipFacility({ membership: newMembership, ippan: newIppan });
        // setDispFacility(dispText)

        // 選択項目の移動

        // const state = store.getState().login
        // let apiKey = null
        // if (Object.keys(state).length !== 0) {
        //     apiKey = state.apiKey
        // }
        // if (apiKey === null) {
        //     store.dispatch({ type: "CLEAR_STATE" })
        //     history.push("/reserve/login", { prevRef: 'vacancy', shisetsuCd: facilityId, date })
        // } else {
        //     history.push('/reserve/hotel/search', { prevRef: 'vacancy', shisetsuCd: facilityId, date })
        // }
        // history.push("/reserve/hotel/search")
        // チェックイン
        // const checkInDate = new Date(date);
        // const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");
        // setCheckIn(checkInDate);

        // // チェックアウト
        // const checkOutDate = new Date(checkInDate);
        // const nightNum = document.getElementById("nights").value;
        // checkOutDate.setDate(checkOutDate.getDate() + Number(nightNum));
        // setCheckOut(checkOutDate);

        // // 室数
        // let vacancyNum = 1;
        // room.forEach(data => {
        //     if (data.selected === true) vacancyNum = parseInt(data.id);
        // });

        // // 1室あたりの人数
        // let adults = 2;
        // adultNum.forEach((data) => {
        //     if (data.selected === true) adults = parseInt(data.id);
        // });
        // let children = 0;
        // childNum.forEach((data) => {
        //     if (data.selected === true) children = parseInt(data.id);
        // });

        // // 施設
        // let facilityArray = [];
        // facilityArray.push(facilityId);
        // let dispText = "";
        // let newMembership = [];
        // membershipFacility.membership.forEach(group => {
        //     group.checked = false;
        //     group.shisetsuList.forEach(item => {
        //         if (item.id === facilityId) {
        //             dispText = dispText + (dispText == "" ? "" : ", ");
        //             dispText = dispText + item.value;
        //             item.checked = true;
        //         } else {
        //             item.checked = false;
        //         }
        //     })
        //     newMembership.push(group);
        // })
        // let newIppan = [];
        // membershipFacility.ippan.forEach(group => {
        //     group.checked = false;
        //     group.shisetsuList.forEach(item => {
        //         if (item.id === facilityId) {
        //             dispText = dispText + (dispText == "" ? "" : ", ");
        //             dispText = dispText + item.value;
        //             item.checked = true;
        //         } else {
        //             item.checked = false;
        //         }
        //     })
        //     newIppan.push(group);
        // })
        // setMembershipFacility({ membership: newMembership, ippan: newIppan });
        // setDispFacility(dispText);

        // // 会員権
        // let keiyakuNo = "";
        // let kaiinkenCd = "";
        // let kaiinkenNo = "";
        // let riyoKaiinkenSyubetCd = "";
        // resvKaiinken.forEach((data) => {
        //     if (data.selected === true) {
        //         keiyakuNo = data.keiyakuNo;
        //         kaiinkenCd = data.id;
        //         kaiinkenNo = data.value;
        //         riyoKaiinkenSyubetCd = data.riyoKaiinkenSyubetCd;
        //     }
        // });

        // // グレード
        // let gradeArray = [];
        // grade.forEach((data) => {
        //     if (data.checked === true) gradeArray.push(data.id);
        // });
        // // 検索条件設定
        // setMembershipSearchParam({
        //     checkInDate: startDate,
        //     checkOutDate: commonUtil.getStringFromDate(checkOutDate, "yyyy-MM-dd"),
        //     nights: nightNum,
        //     shisetsuCdList: facilityArray,
        //     adultCnt: adults,
        //     childCnt: children,
        //     roomCnt: vacancyNum,
        //     keiyakuNo: keiyakuNo,
        //     planConditionsCdList: [],
        //     roomGradeCdList: gradeArray,
        //     foodCdList: [],
        //     privilegedServiceCdList: [],
        //     kaiinkenCd: kaiinkenCd,
        //     kaiinkenNo: kaiinkenNo,
        //     riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd,
        // });
        // history.push("/reserve/membership/searchResult");
    }

    const onClickFacility = (facilityId, facilityName) => {


        // 2週間カレンダーのスタート日
        let startDate2w = new Date(checkIn);

        let startDate = new Date(startDate2w);
        startDate.setMonth(startDate.getMonth() - 1);
        startDate.setDate(25);
        let endDate = new Date(startDate2w);
        endDate.setMonth(endDate.getMonth() + 1);
        endDate.setDate(6);

        const today = new Date();
        if ((today.getFullYear() === startDate2w.getFullYear() && today.getMonth() === startDate2w.getMonth()) || today >= startDate) {
            startDate = new Date(today);
        }

        // 会員権
        let keiyakuNo = "";
        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                keiyakuNo = data.keiyakuNo;
            }
        });

        const req = {
            keiyakuNo,
            startDate,
            endDate,
            shisetsuCd: facilityId,
        }
        onClickOpenFacilityCalendarWindow(req, facilityName);
    }


    const getFacilityShisetsu = (vacancyItem, facilityData) => {
        if(!facilityData) {
            return null;
        }

        let ret = getHotelListShisetsu(vacancyItem, facilityData.generalHotelList);
        if (!ret) {
            ret = getHotelListShisetsu(vacancyItem, facilityData.memberHotelList);
        }
        return ret;

    }

    const getHotelListShisetsu = (vacancyItem, hotelList) => { 
        for (const group of hotelList) {
            for (const shisetsu of group.shisetsuList) {
                if (shisetsu.shisetsuCd === vacancyItem.facilityId) {
                    return shisetsu;
                }
            }
        }
        return null;
    }

    // 改行有り施設名を設定
    const dispVacancyInfo = props.vacancyInfo.map(item => {
        const facilityShisetsu = getFacilityShisetsu(item, facilityData);
        if (!facilityShisetsu) {
            return item;
        }
        const newVacancyItem = {
            ...item,
            facilityName: replaceLineBreakCharToLineBreak(mobilePhone ? facilityShisetsu.webNameSp : facilityShisetsu.webNamePc),
        }
        return newVacancyItem;
    });

    return (
        <div style={{ width: "100%" }}>
            <div style={mobilePhone ? { width: "100%", marginBottom: "40px" } : { width: "80%", overflowY: "auto", overflowX: "hidden", margin: "0px auto" }}>
                <div className={props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ? 'membership_vacancy_acc_info' : "hiddenItem"}>
                    各ホテル名をクリックすると1ヶ月分の空室状況が確認できます
                </div>
                {mobilePhone ?
                    <div style={props.vacancyInfo.length > 3 ? style.tableSP2 : style.tableSP1}>
                        {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined ? props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                            <WeeksDateMobile data={props.vacancyWeek} data2={dispVacancyInfo} flag={nextFlag} onClick={toList} onClickFacility={onClickFacility} />
                            : null : null
                        }
                    </div> :
                    <div style={props.vacancyInfo.length > 4 ? style.tablePC2 : style.tablePC1}>
                        {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined ? props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                            <LoginBfWeeksDate data={props.vacancyWeek} data2={dispVacancyInfo} onClick={toList} onClickFacility={onClickFacility} />
                            : null : null
                        }
                    </div>
                }
            </div>
        </div>
    );
}


const style = {
    container: {
        marginRight: "auto",
        marginLeft: "auto",
    },
    line: {
        clear: "both",
    },
    usageGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",
    },
    rightGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    rightGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    // tablePC1: {
    //     width: "100%",
    //     maxHeight: "450px",
    // },
    // tablePC2: {
    //     width: "100%",
    //     overflowX: "hidden",
    //     overflowY: "scroll",
    //     maxHeight: "450px",
    // },
    tableSP1: {
        width: "100%",
        maxHeight: "250px",
    },
    tableSP2: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
        maxHeight: "250px",
    },
    tableImageStyle: {
        display: "flex",
    },

    imageStyle: {
        width: "11px",
        margin: "auto",
    },
    imageStyleMobile: {
        width: "11px",
        margin: "auto",
    }
}

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        room: state.room,
        resvKaiinken: state.resvKaiinken,
        grade: state.grade,
        membershipFacility: state.membershipFacility,
        adultNum: state.adultNum,
        childNum: state.childNum,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginBfVacancyInfoCallender);